import React, { useState } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
  Box,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LogIn } from 'lucide-react';

const Login = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        "https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/auth/login",
        form,
        { withCredentials: true }
      );
      console.log("Login Response:", response.data);
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        console.log("Stored Token:", localStorage.getItem("token"));
      } else {
        console.error("No token received!");
      }
      setSnackbar({ open: true, message: "Login successful!", severity: "success" });
      navigate("/profile");
    } catch (error) {
      console.error("Login failed:", error.response?.data);
      setSnackbar({ open: true, message: error.response?.data?.message || "Login failed", severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        px: 2,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 380,
          p: 0,
        }}
      >
        {/* Logo */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 2,
              bgcolor: '#2383e2',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
            }}
          >
            <LogIn size={22} color="white" />
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
            Welcome back
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
            Sign in to your inventory dashboard
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <Box>
              <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary', display: 'block', mb: 0.5 }}>
                Email
              </Typography>
              <TextField
                fullWidth
                name="email"
                type="email"
                placeholder="you@example.com"
                required
                onChange={handleChange}
                size="small"
              />
            </Box>
            <Box>
              <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary', display: 'block', mb: 0.5 }}>
                Password
              </Typography>
              <TextField
                fullWidth
                name="password"
                type="password"
                placeholder="Enter your password"
                required
                onChange={handleChange}
                size="small"
              />
            </Box>
            <Button
              fullWidth
              variant="contained"
              type="submit"
              disabled={loading}
              sx={{
                mt: 1,
                py: 1.25,
                bgcolor: '#2383e2',
                fontWeight: 600,
                '&:hover': { bgcolor: '#1b6ec2' },
              }}
            >
              {loading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : "Sign in"}
            </Button>
          </Stack>
        </form>

        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Don't have an account?{' '}
            <Typography
              component="span"
              variant="body2"
              onClick={() => navigate("/signup")}
              sx={{
                color: 'primary.main',
                cursor: 'pointer',
                fontWeight: 500,
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Sign up
            </Typography>
          </Typography>
        </Box>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default Login;
